import styled from "styled-components";

export const StyledErrorScreen = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  position: absolute;
  z-index: 999;
  img {
    margin-top: -100px;
  }
  h4 {
    font-size: 24px;
    margin: 0;
  }
  p {
    font-size: 16px;
    margin: 10px 0 0 0;
    font-weight: 500;
    text-align: center;
  }
`;
